import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FadeIn } from '../ui/FadeIn';
import { ChevronDownIcon, HelpCircleIcon } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Cómo recibo el pack después de comprar?',
    a: 'Inmediatamente después de confirmar el pago recibís un email con el enlace de descarga. Acceso en menos de 5 minutos.'
  }, {
    q: '¿Sirve para cualquier provincia de Argentina?',
    a: 'Sí. El material aplica para cualquier profesional del fitness en todo el país. Acceso digital inmediato sin importar dónde estés.'
  }, {
    q: '¿El contenido aplica para cualquier tipo de entrenamiento?',
    a: 'Sí. El pack cubre ejercicios de musculación, funcional, fuerza y acondicionamiento físico general.'
  }, {
    q: '¿Es editable? ¿Puedo modificarlo?',
    a: 'El material viene en PDF. Podés abrirlo en cualquier dispositivo. No es editable pero está diseñado para consulta rápida.'
  }, {
    q: '¿Los 2 bonos están en todas las opciones?',
    a: 'Sí. Los 2 bonos estratégicos están incluidos en todas las opciones sin costo adicional.'
  }, {
    q: '¿Qué pasa si no me convence?',
    a: 'Tenés 7 días de garantía total. Si no es lo que esperabas te devolvemos el 100% sin preguntas.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-12 bg-background-dark border-y border-card-border-dark relative overflow-hidden" data-id="element-101">
      <div className="container mx-auto px-4 max-w-3xl relative z-10" data-id="element-102">
        <FadeIn className="text-center mb-8" data-id="element-103">
          <h2 className="text-3xl md:text-5xl font-black text-white font-heading uppercase tracking-wider mb-2" data-id="element-104">
            ❓ PREGUNTAS FRECUENTES
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-105">
          {faqs.map((faq, index) => <FadeIn key={index} delay={0.1 * index} direction="up" data-id="element-106">
              <div className="bg-card-dark border border-card-border-dark rounded-2xl overflow-hidden transition-colors hover:border-primary/30" data-id="element-107">
                <button onClick={() => toggleFAQ(index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-108">
                  <div className="flex items-center gap-4" data-id="element-109">
                    <HelpCircleIcon className="w-6 h-6 text-urgency shrink-0" data-id="element-110" />
                    <span className="text-lg font-bold text-white pr-4" data-id="element-111">
                      {index + 1} — {faq.q}
                    </span>
                  </div>
                  <motion.div animate={{
                rotate: openIndex === index ? 180 : 0
              }} transition={{
                duration: 0.3
              }} className="shrink-0" data-id="element-112">
                    <ChevronDownIcon className="w-6 h-6 text-primary" data-id="element-113" />
                  </motion.div>
                </button>
                <AnimatePresence data-id="element-114">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-115">
                      <div className="px-6 pb-6 text-gray-400 leading-relaxed border-t border-card-border-dark pt-4 ml-10" data-id="element-116">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}